<template>
  <AvatarRoot :class="cn(variants({ size, shape }), props.class)">
    <AvatarImage v-if="!placeholder && !text" :src="`${src}`" :alt="name" />
    <AvatarFallback v-if="!placeholder && initials">
      {{ initials }}
    </AvatarFallback>
    <AvatarFallback v-else>
      <Icon name="user-single" id="placeholder" />
    </AvatarFallback>
  </AvatarRoot>
</template>

<script setup>
import { AvatarRoot } from "radix-vue";
import { AvatarFallback, AvatarImage, sizes, shapes, variants } from ".";
import { Icon } from "@/SharedComponents/Icon";
import { cn } from "@/Utils/cn";

const props = defineProps({
  src: { type: String, default: null },
  name: { type: String, default: "" },
  initials: { type: String, required: false },
  size: {
    type: String,
    validator: (val) => sizes.includes(val),
    required: false,
  },
  shape: {
    type: String,
    validator: (val) => shapes.includes(val),
    required: false,
  },
  placeholder: { type: Boolean, default: false },
  text: { type: Boolean, default: false },
  class: { type: null, required: false },
});
</script>
